// import * as ACTION from '../Actions/actionTypes';
import * as ACTION from "../actions/GetViewType/SetViewTypeActionType"
import { UpdateObject } from "../../utils/utils";

const initialState = {
  viewType: "",
};

const ViewTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.SET_VIEW_TYPE:
      return getViewType(state, action);

    default:
      return state;
  }
};

const getViewType = (state, action) => {
  localStorage.setItem("viewType", action.payload);
  return UpdateObject(state, {
    viewType: action.payload,
  });
};

export default ViewTypeReducer;